import { queryClient } from '../../queryClient'

/**
 * After an agent turn: the agent may have saved, moved or deleted tables
 * (pt toc save / delete), so every table list on screen reads its tree again
 * (the agent's Tables tab, and any picker keyed ['toc', customer, job]).
 * Only the lists being shown refetch; the rest read fresh when next opened.
 */
export const refreshTablesAfterTurn = () => {
  void queryClient.invalidateQueries({ queryKey: ['toc'] })
}
